import React, { Component } from 'react'
import {
  Container,
  Grid,
  Header,
  Divider,
  Dimmer,
  Loader,
  Button
} from 'semantic-ui-react'

import ProductCard from '../components/ProductCard'
import CategorySelector from '../components/CategorySelector'

// redux
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  getProducts,
  addToCart,
  getCart,
  getCategories,
  getSizeGuide
} from '../actions/product'

class CatalogPage extends Component {
  componentWillMount() {
    const [offset, limit, categoryId] = [0, 25, null]
    this.setState({
      offset,
      limit
    })
    this.props.getProducts({
      offset,
      limit,
      categoryId
    })
    this.props.getCart({})
    this.props.getCategories()
    this.props.getSizeGuide()
  }
  filterCategory(categoryId) {
    let { offset, limit } = this.state
    offset = 0
    this.setState({
      offset,
      categoryId
    })
    this.props.getProducts({ offset, limit, categoryId })
  }

  loadMore() {
    let { offset, limit, categoryId } = this.state
    offset = offset + limit
    this.setState({ offset })
    this.props.getProducts({
      offset,
      limit,
      categoryId
    })
  }

  addToCart(productVariantId, qty = 1) {
    this.props.addToCart(
      {
        userId: this.props.user.detail.id,
        productVariantId,
        qty
      },
      qty > 1
    )
  }

  render() {
    const {
      products,
      isCatalogLoading,
      categories,
      sizeGuide
    } = this.props.product
    return (
      <Container fluid>
        <Dimmer active={isCatalogLoading} inverted page blurring>
          <Loader active={isCatalogLoading}>Loading...</Loader>
        </Dimmer>

        <Grid>
          <Grid.Row columns="equal">
            <Grid.Column computer={3} tablet={3} only="tablet computer">
              <CategorySelector
                categories={categories}
                selectedCategory={this.state.categoryId}
                filterCategory={this.filterCategory.bind(this)}
              />
            </Grid.Column>
            <Grid.Column>
              <Header as="h3">Product Catalog</Header>
              <Divider />
              <Grid columns="equal">
                {products.map(product =>
                  <ProductCard
                    key={product.id}
                    product={product}
                    addToCart={this.addToCart.bind(this)}
                    sizeGuide={sizeGuide}
                  />
                )}
              </Grid>
              {products.length === this.state.limit
                ? <Grid columns="equal" centered>
                    <Grid.Column computer={4}>
                      <Button
                        fluid
                        basic
                        circular
                        onClick={this.loadMore.bind(this)}
                      >
                        Load More
                      </Button>
                    </Grid.Column>
                  </Grid>
                : null}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    )
  }
}

const mapStateToProps = state => {
  return state
}

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      getCategories,
      getProducts,
      addToCart,
      getCart,
      getSizeGuide
    },
    dispatch
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(CatalogPage)



// WEBPACK FOOTER //
// ./src/pages/Catalog.jsx